import { render, staticRenderFns } from "./QuestionsPage.vue?vue&type=template&id=124524fc&scoped=true&"
import script from "./QuestionsPage.vue?vue&type=script&lang=js&"
export * from "./QuestionsPage.vue?vue&type=script&lang=js&"
import style0 from "./QuestionsPage.vue?vue&type=style&index=0&id=124524fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124524fc",
  null
  
)

export default component.exports